import { PanelType } from '@fluentui/react';
import { ConstrainMode, DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';
import React, { Component } from 'react';
import { DataCompte } from '../../data/DataCompte';
import { DataContact } from '../../data/DataContact';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUISeparator } from '../EUI/EUISeparator';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheContactTransfertPropriete.css';

export class FicheContactTransfertPropriete extends Component {

    static defaultProps = {
        listeIdContacts: [],
        onDismiss: () => null,
        onSave: () => null,
    };

    static defaultState = {
        items: [],
        listeCommercialisateursSource: [],
        idSocieteCible: 0,
        loginCompteCible: '',
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheContactTransfertPropriete.defaultState };
        this._columns = this._getColumns();
        this._selection = new Selection({ onSelectionChanged: this._onSelectionChanged })
    };

    _getColumns = () => {
        return [{
            isResizable: true,
            key: 'societe',
            minWidth: 100,
            maxWidth: 200,
            name: 'Société',
            onRender: (item) => {
                const societe = item.societe;
                return <span title={societe}>{societe}</span>;
            }
        }, {
            isResizable: true,
            key: 'commercialisateur',
            minWidth: 100,
            maxWidth: 200,
            name: 'Commercialisateur',
            onRender: (item) => {
                const commercialisateur = item.prenom + ' ' + item.nom;
                return <span title={commercialisateur}>{commercialisateur}</span>;
            }
        }];
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des commercialisateurs en cours'
        });

        const { listeIdContacts } = this.props;

        DataCompte._chargementDesComptesEtantProprietaireDesContacts(listeIdContacts).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const items = responseFetch.reponseAPIobjet;
                const state = { items };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);

                // KP - 2486 - 24/07/2023 : sélectionner tous les propriétaires peu importe le nombre
                //if (items.length === 1)
                this._selection.setAllSelected(true);
            }
            else {
                const state = {
                    items: [],
                    listeIdContacts: [],
                };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });

    };

    _onDismiss = () => {
        const { onDismiss } = this.props;
        this.setState({ ...FicheContactTransfertPropriete.defaultState }, onDismiss);
    };

    _onEnregistrementTransfert = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement en cours'
        });

        const { listeIdContacts, onSave } = this.props;
        const { listeCommercialisateursSource, loginCompteCible } = this.state;

        DataContact._onEnregistrementTransfertProprieteContact(listeIdContacts, listeCommercialisateursSource, loginCompteCible)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null)
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onSave);
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };


    _onOpen = () => {
        const { listeIdContacts } = this.props;
        this.setState({ ...FicheContactTransfertPropriete.defaultState });
        if (!!listeIdContacts && Array.isArray(listeIdContacts) && listeIdContacts.length > 0)
            this._chargementDonnees();
    };

    _onSelectionChanged = () => {
        const listeCommercialisateursSource = this._selection.getSelection().map(compte => compte.loginCompte);
        this.setState({ listeCommercialisateursSource });
    };

    _validationFormulaire = () => {

        const { listeIdContacts } = this.props;
        const { listeCommercialisateursSource, loginCompteCible } = this.state;

        const estValide = true
            && !!listeIdContacts && Array.isArray(listeIdContacts) && listeIdContacts.length > 0
            && !!loginCompteCible
            && !!listeCommercialisateursSource && Array.isArray(listeCommercialisateursSource) && listeCommercialisateursSource.length > 0;

        return estValide;

    };

    render = () => {

        const { isOpen } = this.props;
        const { idSocieteCible, items, loginCompteCible } = this.state;

        return <EUIPanel
            headerText="Transfert de propriété"
            isFormValid={this._validationFormulaire()}
            isOpen={isOpen}
            onDismiss={this._onDismiss}
            onOpen={this._onOpen}
            onSave={this._onEnregistrementTransfert}
            type={PanelType.medium}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Label>Liste des commercialisateurs propriétaires</Label>
            <DetailsList
                columns={this._columns}
                constrainMode={ConstrainMode.unconstrained}
                items={items}
                selection={this._selection}
                selectionMode={SelectionMode.multiple}
                selectionPreservedOnEmptyClick
            />

            <EUISeparator />
            <div>Transférer vers</div>

            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <ComboBoxSociete
                            onChange={(event, option) => this.setState({ idSocieteCible: option.key, loginCompteCible: "" })}
                            required
                            selectedKey={idSocieteCible}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <ComboBoxCompte
                            avecValeurDefaut={false}
                            disabled={!idSocieteCible}
                            idSociete={idSocieteCible}
                            idsTypesMandats={[2]}
                            label="Commercialisateur"
                            onChange={(event, option) => this.setState({ loginCompteCible: option.key })}
                            required
                            selectedKey={loginCompteCible}
                        />
                    </div>
                </div>
            </div>
        </EUIPanel>;

    };

};